/**
 * IntlPhoneWrapper — intl-tel-input 래퍼.
 * intl-tel-input import는 이 파일에서만 허용.
 *
 * 기능:
 * - intlTelInput 인스턴스 생성
 * - locale hidden input 자동 생성 (name + "_locale", ISO 2-letter code)
 * - 국가 변경 시 locale hidden input 자동 업데이트
 */

import intlTelInput from "intl-tel-input";

type ItiOptions = Parameters<typeof intlTelInput>[1];

export class IntlPhoneWrapper {
    private instance: ReturnType<typeof intlTelInput> | null = null;
    private localeInput: HTMLInputElement | null = null;

    constructor(
        private readonly input: HTMLInputElement,
        private readonly options: ItiOptions = {}
    ) {}

    init(): this {
        this.instance = intlTelInput(this.input, this.options);

        const hidden = document.createElement("input");
        hidden.type = "hidden";
        hidden.name = (this.input.name || "") + "_locale";
        hidden.value = this.instance.getSelectedCountryData().iso2 ?? "";
        this.input.insertAdjacentElement("afterend", hidden);
        this.localeInput = hidden;

        this.input.addEventListener("countrychange", () => {
            if (this.localeInput) {
                this.localeInput.value = this.instance?.getSelectedCountryData().iso2 ?? "";
            }
        });

        return this;
    }

    getValue(): string {
        return this.instance?.getNumber() ?? this.input.value;
    }

    isValid(): boolean {
        return this.instance?.isValidNumber() ?? false;
    }

    destroy(): void {
        this.instance?.destroy();
        this.localeInput?.remove();
        this.instance = null;
        this.localeInput = null;
    }
}

export function initIntlPhoneInputs(root: Element | Document = document): void {
    root
        .querySelectorAll<HTMLInputElement>("[data-intl-phone]:not([data-iti-inited])")
        .forEach((input) => {
            input.dataset.itiInited = "1";
            new IntlPhoneWrapper(input).init();
        });
}
